/* This file is autogenerated, see readme.md for instructions */
import ConditionAltSvgIcon from '@bloomreach/banana-theme/icons/condition-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ConditionAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ConditionAltSvgIcon />
    </Icon>
  );
});

ConditionAltIcon.displayName = 'ConditionAltIcon';

export default ConditionAltIcon;
